import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-popup-ranking-campaigns',
  templateUrl: './popup-ranking-campaigns.component.html',
  styleUrls: ['./popup-ranking-campaigns.component.scss'],
})
export class PopupRankingCampaignsComponent implements OnInit {
  @Input() data: {
    title: string
    list: { label: string; value: number; unit: ''; numeric: boolean }[]
  }[] = []
  @Input() labelKey = 'name'
  @Input() valueKey = 'nvisits'
  @Input() title = ''
  @Input() columns: {
    title: string
    key: string
    sortable: boolean
    selected: boolean
  }[] = []
  @Output() onCloseClick = new EventEmitter()

  sortBy = null

  options = []
  selected = null
  comparedOption = false
  tableContent = []

  constructor() {}

  ngOnInit() {
    this.options = (this.data || []).map((d, idx) => ({
      label: d.title,
      value: idx,
    }))
    this.selected = this.options[0]
    this.comparedOption = false
    this.tableContent = this.data[0].list
  }

  closePopup() {
    this.onCloseClick.emit()
  }

  changeOption(el) {
    this.selected = el
    this.comparedOption = el.value > 0
    this.tableContent = this.data[el.value].list
  }

  isSortBy(column) {
    return this.sortBy && this.sortBy.includes(column)
  }

  isSortDesc(column) {
    return this.isSortBy(column) && this.sortBy === `-${column}`
  }

  sort(column) {
    const desc = this.isSortDesc(column.key)
    this.sortBy = `${desc ? '+' : '-'}${column.key}`
    this.columns.forEach((c) => {
      c.selected = column.key === c.key
    })
    this.data.forEach((r) => {
      r.list.sort((a, b) => {
        if (a.numeric) {
          return desc
            ? b[column.key] - a[column.key]
            : a[column.key] - b[column.key]
        } else {
          if (a[column.key] < b[column.key]) {
            return desc ? 1 : -1
          }
          if (a[column.key] > b[column.key]) {
            return desc ? -1 : 1
          }
          return 0
        }
      })
    })
  }
}
